export default __webpack_public_path__ + "static/media/IMG-20241005-WA0051.2a1a9658.jpg";